import React, { useState, useEffect } from 'react';
import { DillButton } from '../../../general/Dill/DillButton';
import { DillModal } from '../../../general/Dill/DillModal';
import { AppInputField } from '../../../general/AppInputField/AppInputField';
import { InvitedSignatures } from '@dill/dill-shared';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { updateSupplierCreditApplication } from '../../../../redux/services/creditApplicationsService';
import { openDillToast } from '../../../../utils/helpers';

const EditSignatureEmailModal = ({
  open,
  handleClose,
  signatureDetails,
  applicationId,
}: {
  open: boolean;
  handleClose: () => void;
  signatureDetails: InvitedSignatures;
  applicationId: string;
}) => {
  const [emailVal, setEmailVal] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>();
  const [comment, setComment] = useState('');

  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);

  useEffect(() => {
    if (open && signatureDetails && signatureDetails.email) {
      setEmailVal(signatureDetails.email);
    }
  }, [open]);

  const validateInputs = () => {
    let errorField = '';
    if (emailVal.trim() === '') {
      errorField = 'Email is required';
    } else {
      const emailRegex = /[\w.+-]+@[\w-]+\.[a-z]{1,}/gi;
      const isMatch = emailRegex.test(emailVal);
      if (!isMatch) {
        errorField = 'Email is not valid';
      }
    }

    setError(errorField);
    return errorField.trim() === '';
  };

  const handleCloseModal = () => {
    setError('');
    setEmailVal('');
    setComment('');
    setIsLoading(false);
    handleClose();
  };

  const handleUpdateSignatureEmail = async () => {
    if (!validateInputs()) return;
    setIsLoading(true);
    const data = { ...signatureDetails, email: emailVal };

    let details = {};
    if (comment.trim() !== '') {
      details = { ...details, comment };
    }
    const results = await dispatch(
      updateSupplierCreditApplication({
        creditApplicationId: applicationId,
        supplierId: currentSupplier?.id || '',
        invitedSignature: data,
        savingType: 'update-signature-email',
        ...details,
      })
    );
    if (results && results.type.includes('fulfilled')) {
      openDillToast({
        type: 'SUCCESS',
        message: 'Successfully updated the signature email.',
      });
    } else {
      openDillToast({
        type: 'ERROR',
        message: 'Failed to update signature email.',
      });
    }

    setIsLoading(false);
    handleCloseModal();
  };

  return (
    <DillModal
      open={open}
      onClose={handleCloseModal}
      title="Edit Signature Email"
      width="540px"
      footer={
        <>
          <DillButton
            label="Cancel"
            variant="secondary"
            onClick={handleCloseModal}
            isDisabled={isLoading}
          />
          <DillButton
            label="Send Email"
            onClick={handleUpdateSignatureEmail}
            isDisabled={isLoading}
            isLoading={isLoading}
          />
        </>
      }>
      <div className="w-full">
        <AppInputField
          id="emai"
          label="Email"
          isRequired
          placeholder="Enter Signature Email"
          errorText={error}
          value={emailVal}
          onTextChange={(text) => {
            setEmailVal(text);
            setError('');
          }}
        />
      </div>
      <div className="w-full">
        <AppInputField
          label="Comment"
          value={comment}
          inputType="textarea"
          onTextChange={(val) => {
            setComment(val);
          }}
        />
      </div>
    </DillModal>
  );
};

export default EditSignatureEmailModal;
